var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "DropdownFilter",
    _vm._g(
      _vm._b(
        {
          attrs: {
            max: _vm.max,
            customMultiStyleParent: _vm.getcontainerStyle,
            cref: _vm.cref,
          },
          on: { setRef: _vm.onSetRef },
          scopedSlots: _vm._u([
            {
              key: "tag",
              fn: function ({ option, remove }) {
                return [
                  _c("MultiselectAvatarTag", {
                    attrs: {
                      option: option,
                      parentStyles: _vm.parentStyles,
                      removable: "",
                    },
                    on: { remove: remove },
                  }),
                ]
              },
            },
            {
              key: "singleLabel",
              fn: function ({ option }) {
                return [
                  option
                    ? _c("TableAvatar", {
                        attrs: {
                          image: option.avatar,
                          initial: _vm.getInitials(
                            option.given_name,
                            option.family_name
                          ),
                          title: _vm.getFullName(
                            option.given_name,
                            option.family_name
                          ),
                          primary: "",
                        },
                      })
                    : _vm._e(),
                ]
              },
            },
            {
              key: "option",
              fn: function ({ option }) {
                return [
                  _c(
                    "div",
                    { staticClass: "flex items-center justify-between w-full" },
                    [
                      _c("MultiselectAvatar", {
                        attrs: { option: option },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "image",
                              fn: function ({ image, defaultClasses }) {
                                return [
                                  _c("S3Image", {
                                    staticClass: "bg-white",
                                    class: defaultClasses,
                                    attrs: { s3FileKey: image },
                                  }),
                                ]
                              },
                            },
                            {
                              key: "initial",
                              fn: function ({ defaultClasses, initial }) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "avatar bg-badgeBlue",
                                      class: defaultClasses,
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "flex items-center h-full text-xs leading-5 text-white",
                                        },
                                        [_vm._v(_vm._s(initial))]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _vm.bookmarkedUsers.has(
                        option.userId || option.user_id || option.id
                      )
                        ? _c("BookmarkIcon", {
                            staticClass: "ml-2",
                            attrs: { bookmarked: true, size: "w-4 h-4" },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        "DropdownFilter",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }